import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PageResult } from '../shared/models/pageResult';
import { environment } from 'src/environment';
import { Observable, of } from 'rxjs';
import { FilterItemList, SelectedFilter } from '../shared/models/filter.model';
import { DistributionGroup } from '../models/distribution-group.model';

export interface GroupOption {
  id: number;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class DistributionGroupApiService {

  #httpservice = inject(HttpClient);
  #baseUrl = environment.apiUrl;
  #specBaseUrl = `${this.#baseUrl}/distributionGroups`

  updateDistributionGroup = (distributionGroup: DistributionGroup) => this.#httpservice.post<DistributionGroup>(`${this.#specBaseUrl}/update`, distributionGroup);
  createDistributionGroup = (distributionGroup: DistributionGroup) => this.#httpservice.post<DistributionGroup>(`${this.#specBaseUrl}/create`, distributionGroup);
  changeStatusDistributionGroup = (distributionGroupId: number) => this.#httpservice.get<number>(`${this.#specBaseUrl}/changeStatus/${distributionGroupId}`);

  getAllDistributionGroups = (page: number, selectedFilter: any) => {
    return this.#httpservice.post<PageResult<DistributionGroup>>(`${this.#specBaseUrl}/getAllDistributionGroups`, { paging: page, selectedFilter: selectedFilter });
  }

  getDistributionGroupsForExtra = (page: number, selectedFilter: any) => {
    return this.#httpservice.post<PageResult<DistributionGroup>>(`${this.#specBaseUrl}/getExtraAllDistributionGroups`, { paging: page, selectedFilter: selectedFilter });
  }

  getApproverGroups = () => this.#httpservice.get<GroupOption[]>(`${this.#specBaseUrl}/approverGroups`);

  getGroupTypes = () => this.#httpservice.get<GroupOption[]>(`${this.#specBaseUrl}/groupTypes`);

  getFilterItemList(): Observable<FilterItemList[]> {
    const res: FilterItemList[] =
      [
        {
          "id": 2,
          "displayNameEn": "Distribution date",
          "displayNameHe": "תאריך הפצה",
          "fieldName": "startDate",
          "typeFilter": 1
        },
        {
          "id": 3,
          "displayNameHe": "יוצר השאלון",
          "displayNameEn": "Questionnaire creator",
          "fieldName": "creator",
          "typeFilter": 1
        },
      ];
    return of(res);
  }
}
